import React from 'react';

import clsx from 'clsx';

const CampaignSetupCard = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => (
    <div
      ref={ref}
      className={clsx(
        'shadow hover:shadow-md flex w-[900px] p-4 flex-col items-start border bg-neutral-0 border-neutral-200 rounded-lg gap-4',
        className,
      )}
      {...props}
    />
  ),
);

CampaignSetupCard.displayName = 'Card';

export default CampaignSetupCard;
